@if (alertDialogActive && !alertClosedByUser && (isCustomerDataLoaded || (userLoggedIn$ | async) === false)) {
  <div role="alertdialog"
       aria-labelledby="alert1Title"
       aria-describedby="alert1Text"
       class="alert main-alert is-open">
    <div class="alert__container">
      <button type="button"
              class="alert__close"
              data-dismiss="alert"
              aria-label="Close alert"
              (click)="toggleAlertDialog()">
        <i aria-hidden="true" class="icon-close"></i>
      </button>
      @if (((userLoggedIn$ | async) && isGuest && isAuthenticatedGuest()) || isNotLoggedMessage()) {
        <p class="alert__text font-size-small">
          <a (click)="register()">{{ 'app-bar.register' | translate }}</a>
          @if ((userLoggedIn$ | async) === false) {
            <span> {{ 'app-bar.tooltip-conj' | translate }} </span>
            <a (click)="login()">{{ 'app-bar.login' | translate }}</a>
          }
          {{ 'app-bar.tooltip-text' | translate }}
        </p>
      } @else {
        <div class="alert__body wysiwyg">
          <p class="alert__text font-size-small">
            {{alertText}}
          </p>
        </div>
      }
    </div>
  </div>
}
